import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    IconButton,
    InputAdornment,
    Typography
} from '@mui/material';
import apiMcu from 'api/mcu';
import { IconClose } from 'assets/icons';
import { TooltipCC } from 'components/common';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { InfoOutlinedIconCC } from 'pages/manager-meeting/components/ScheduleMeeting';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from 'theme';
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers';
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';

function validate(key, value, t) {

    switch (key) {
        case 'user':
            if (value?.length === 0) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.user.require',
                };
            }
            if (value?.length > 64) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.user.max-length',
                };
            }
            return {
                value: false,
                helperText: '',
            };
        case 'pass':
            if (value?.length === 0) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.pass.require',
                };
            }
            if (value?.length < 8) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.pass.min-length',
                };
            }
            if (value?.length > 64) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.pass.max-length',
                };
            }
            return {
                value: false,
                helperText: '',
            };
        case 'server':
            if (value?.length === 0) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.user.require',
                };
            }
            if (value?.length > 64) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.user.max-length',
                };
            }
            return {
                value: false,
                helperText: '',
            };
        case 'displayName':
            if (value?.length === 0) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.displayName.require',
                };
            }
            if (value?.length > 64) {
                return {
                    value: true,
                    helperText: 'mcu.helperText.validate.displayName.max-length',
                };
            }
            return {
                value: false,
                helperText: '',
            };
        default:
            break;
    }
}

const DialogCreateSipUser = () => {
    const propsDialog = useLegacyDialogProps();
    const { title, titleButtonAction, titleButtonCancel, data, agreeAction } = propsDialog;
    const { open } = useSelector((state) => state.dialog);

    const { t } = useTranslation();
    const [, setErrorWhenRoomIsProgressed] = useState(false);

    const [newItem, setNewItem] = useState({
        user: '',
        pass: '',
        server: '',
        displayName: ''
    });
    const handleValidateMCURoom = (data, t) => {
        const error = {
            user: { value: false, helperText: '' },
            pass: { value: false, helperText: '' },
            server: { value: false, helperText: '' },
            displayName: { value: false, helperText: '' }
        };

        Object.keys(error).forEach((key) => (error[key] = validate(key, data[key], t)));
        return error;
    };
    const [errorValid, setErrorValid] = useState(() => handleValidateMCURoom(newItem, t));
    const [clickSubmit, setClickSubmit] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const apiCreateSipAccount = (newItem) => {
        return apiMcu.createSipAccount(newItem);
    };

    const apiUpdateSipAccount = (body, id) => {
        return apiMcu.updateSipAccount(body, id);
    }

    const handleCreateSip = (newItem) => {
        if (title !== t('mcu.dialog.title.editAccount')) {
            const body = {
                username: newItem.user.trim(),
                password: newItem.pass.trim(),
                domain: newItem.server.trim(),
                callerIdName: newItem.displayName.trim(),
                callerIdNumber: newItem.user.trim()

            }
            apiCreateSipAccount(body)
                .then((result) => {
                    toastSuccess(t('mcu.toast.createRoomSuccessfully'))
                    agreeAction();
                })
                .catch((error) => {
                    if (error?.response?.data?.code === "ROOM_NUMBER_EXISTS") {
                        toastError(t('mcu.toast.roomCodeIsExisted'))
                    } else {
                        toastError(t('mcu.toast.error'))
                    }
                })
                .finally(() => {
                    setIsUpdating(false)
                    handleCloseDialog();
                });
        } else {
            const body = {
                username: newItem.user.trim(),
                password: newItem.pass.trim(),
                domain: newItem.server.trim(),
                callerIdName: newItem.displayName.trim(),
                callerIdNumber: data.callerIdNumber.trim()
            }
            apiUpdateSipAccount(body, data.id)
                .then((result) => {
                    toastSuccess(t('mcu.toast.updateSuccess'))
                    agreeAction();
                })
                .catch(error => {
                    toastError(t('mcu.toast.error'))
                })
                .finally(() => {
                    setIsUpdating(false)
                    handleCloseDialog();
                });
        }
    };

    const handleCloseDialog = () => {
        setCloseDialogCC();
        setNewItem({
            user: '',
            pass: '',
            server: '',
            displayName: ''
        });
    };

    const handleAction = () => {
        setClickSubmit(true);
        setIsUpdating(true);
        if (errorValid['user']?.value) {
            setIsUpdating(false);
        } else if (errorValid['pass']?.value) {
            setIsUpdating(false);
        } else if (errorValid['displayName']?.value) {
            setIsUpdating(false);
        } else if (errorValid['server']?.value) {
            setIsUpdating(false);
        } else {
            handleCreateSip(newItem);
        }
    };

    useEffect(() => {
        setErrorValid((prev) => handleValidateMCURoom(newItem, t));
    // eslint-disable-next-line
    }, [newItem]);

    useEffect(() => {
        if (data) {
            setNewItem({
                user: data?.user,
                pass: data?.pass,
                server: data?.server,
                displayName: data?.displayName
            });
        }
    }, [data]);

    useEffect(() => {
        if (!open) {
            setNewItem({
                user: '',
                pass: '',
                server: '',
                displayName: ''
            });
            setErrorValid({
                user: { value: false, helperText: '' },
                pass: { value: false, helperText: '' },
                server: { value: false, helperText: '' },
                displayName: { value: false, helperText: '' }
            });
            setClickSubmit(false);
            setErrorWhenRoomIsProgressed(false);
        }
    }, [open]);

    return (
        <DialogBaseCC id={DIALOG_ID.CREATE_SIP_USER} title={title}>
            <DialogContent sx={{ minWidth: '500px !important' }}>
                <DialogContentText>
                    <Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography sx={{ color: color.black }}>
                                {t('mcu.dialog.content.user')}<span style={{ color: color.main }}>*</span>
                            </Typography>
                            <TextFieldVMP
                                placeholder={t('mcu.placeholder.enterUser')}
                                autoFocus
                                error={clickSubmit && errorValid['user']?.value}
                                helperText={clickSubmit && t(errorValid['user']?.helperText)}
                                value={newItem.user}
                                onChange={(e) => {
                                    setNewItem({
                                        ...newItem,
                                        user: e.target.value,
                                    });
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.user !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            user: '',
                                                        });
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography sx={{ color: color.black }}>
                                {t('mcu.dialog.content.displayName')}<span style={{ color: color.main }}>*</span>
                            </Typography>
                            <TextFieldVMP
                                placeholder={t('mcu.placeholder.enterDisplayName')}
                                error={clickSubmit && errorValid['displayName']?.value}
                                helperText={clickSubmit && t(errorValid['displayName']?.helperText)}
                                value={newItem.displayName}
                                onChange={(e) => {
                                    setNewItem({
                                        ...newItem,
                                        displayName: e.target.value,
                                    });
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.displayName !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            displayName: '',
                                                        });
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography sx={{ color: color.black, display: 'flex' }}>
                                {t('mcu.dialog.content.pass')}<span style={{ color: color.main }}>*</span>
                                <Box sx={{marginLeft: '4px'}}>
                                    <TooltipCC placement="top-start" title={t('mcu.helperText.validate.pass.min-length')}>
                                        <InfoOutlinedIconCC />
                                    </TooltipCC>
                                </Box>
                            </Typography>
                            <TextFieldVMP
                                placeholder={t('mcu.placeholder.enterPass')}
                                error={clickSubmit && errorValid['pass']?.value}
                                helperText={clickSubmit && t(errorValid['pass']?.helperText)}
                                value={newItem.pass}
                                onChange={(e) => {
                                    setNewItem({
                                        ...newItem,
                                        pass: e.target.value,
                                    });
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.pass !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            pass: '',
                                                        });
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography sx={{ color: color.black }}>
                                {t('mcu.dialog.content.server')}<span style={{ color: color.main }}>*</span>
                            </Typography>
                            <TextFieldVMP
                                placeholder={t('mcu.placeholder.enterServer')}
                                error={clickSubmit && errorValid['server']?.value}
                                helperText={clickSubmit && t(errorValid['server']?.helperText)}
                                value={newItem.server}
                                onChange={(e) => {
                                    setNewItem({
                                        ...newItem,
                                        server: e.target.value,
                                    });
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.server !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            server: '',
                                                        });
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        handleCloseDialog();
                    }}
                >
                    {titleButtonCancel}
                </Button>
                <LoadingButton
                    variant="contained"
                    loading={isUpdating}
                    onClick={() => {
                        setClickSubmit(true);
                        handleAction();
                    }}
                    disabled={newItem.user === '' || newItem.pass === '' || newItem.server === '' || newItem.displayName === ''}
                >
                    {titleButtonAction}
                </LoadingButton>
            </DialogActions>
        </DialogBaseCC>
    );
};

export default DialogCreateSipUser;
